import styled from "styled-components";

export const LabelContainer = styled.div`
	label {
		display: flex;
		flex-direction: column;
		row-gap: 5px;
		margin-bottom: 1em;

		p {
			font-size: 1em;
			margin: 0;
		}

		input {
			padding-left: 1em;
			height: 45px;
			border: 1px solid #d9d9d9;
		}

		span.require {
			color: tomato;
			font-size: 14px;
			padding-top: 2px;
		}
	}
`;

export const Container = styled.section`
	@media screen and (min-width: 0px) {
		header {
			display: flex;
			flex-direction: column-reverse;
			margin-top: 2em;

			h1 {
				margin-top: 0;
			}
		}

		.button-group {
			width: 100%;
			margin-top: 2em;
			margin-bottom: 4em;

			& * {
				max-width: 100% !important;
			}

			.btn-primary {
				margin-bottom: 1em;
			}
		}

		div.actions {
			a {
				display: inline-block;

				&:nth-of-type(2) {
					margin-top: 4px;
				}
			}
		}

		.popup-dialog {
			position: absolute;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.8);
			z-index: 1000;
			display: flex;
			flex-direction: column;
			align-items: center;
			overflow-x: auto;

			.popup-dialog__content {
				background: var(--white);
				width: 800px;
				max-width: 90vw;
				margin-top: 60px;
				margin-bottom: 60px;
				padding: 15px 30px;
				border-radius: 8px;

				dialog {
					position: relative;
					border: 0;
					background: none;
					display: flex;
					flex-direction: column;
					align-items: center;

					menu {
						display: flex;
						margin: 0;
						padding: 0;

						button:disabled {
							cursor: default;
							opacity: 0.5;
						}

						button {
							flex: 1 1 auto;
							min-width: 80px;
						}

						button:nth-of-type(2) {
							margin-left: 15px;
						}
					}
				}
			}
		}
	}

	@media screen and (min-width: 992px) {
		header {
			text-align: center;
			margin-bottom: 3em;

			h1 {
				margin-top: 0.3em;
			}
		}

		.desktop-block {
			display: flex;
			flex-direction: column;

			.block {
				display: flex;
				justify-content: flex-end;
			}

			.btn-secundary {
				min-width: 100%;
				margin-top: 2.4em;
				margin-bottom: 3em;
			}
		}

		.desktop-title {
			font-family: "PFSquareSansProBold", sans-serif;
			font-size: 18px;
			line-height: 27px;
			text-transform: uppercase;
		}
	}
`;
